import { Box, HStack, VStack } from '@genial/components';
import React from 'react';

import { TableContent } from '../../../../../../../../components/TableContent';
import {
  ColoredSkeleton,
  DetailsSkeleton,
  StatusSkeleton,
  TextSkeleton,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export const FixedFeeTermsRowLoadingMobile: React.FC = () => {
  return (
    <TableContent direction="column" alignItems="stretch" space="stack.xxxs">
      <HStack justifyContent="space-between" alignItems="flex-start" space="inline.nano">
        <VStack space="inline.quarck" flex={1}>
          <HStack space="inline.quarck" alignItems="center">
            <TextSkeleton w="45%" />
            <ColoredSkeleton width="18px" height="18px" borderRadius="full" />
          </HStack>
          <StatusSkeleton w="35%" />
        </VStack>
        <DetailsSkeleton />
      </HStack>

      <Box h="1px" bg="neutral.lightest" />

      <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
        <TextSkeleton w="60%" />
        <DetailsSkeleton />
      </HStack>
    </TableContent>
  );
};
